import React, {useRef, useState} from 'react';
import SearchIcon from '../../../assets/img/icons/search.svg'
import CancelIcon from '@material-ui/icons/Cancel';

import './BILSearchInput.scss';

/**
 * Generic component for search.
 * Allow user to enter some text for search purposes.
 * The component itself does not have lot of logic but expose useful callbacks (clean, change, enter)
 * The placeholder is not handled directly by the input to avoid problems with translations
 */
const BILSearchInput = ({
                            placeholder,
                            disabled,
                            maxLength,
                            value,
                            onChange,
                            onPressEnter,
                            onClear,
                        }) => {
    const inputRef = useRef(null);
    const [focused, setFocused] = useState(false);

    const onFocus = () => {
        if (!disabled) {
            inputRef.current.focus();
            setFocused(true);
        }
    };

    const onBlur = () => {
        if (!disabled) {
            setFocused(false);
        }
    };

    return (
        <div
            className={`bil-search-input ${disabled ? 'disabled' : ''}`}
            onClick={onFocus}
            onBlur={onBlur}>
            <div className="bil-search-input-clickable-area">
                <input
                    ref={inputRef}
                    type="text"
                    value={value}
                    maxLength={maxLength}
                    onChange={(evt) => onChange(evt.target.value)}
                    disabled={disabled}
                />
                {!focused && !value && (
                    <span className="bil-search-input-placeholder">
                            <img className={"bil-search-input-placeholder-icon"} alt="Search" src={SearchIcon}/>
                  <span className="bil-search-input-placeholder-text">
                     {placeholder}
                  </span>
               </span>
                )}
                {value && (
                    <span className="bil-search-input-clear" onClick={onClear}>
                  <CancelIcon className="bil-search-input-clear-icon" />
               </span>
                )}
            </div>
        </div>
    );
};

export default BILSearchInput;
